const makeid = (length) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};

const generalUpsells = (data) => {
  let query = `{`;

  data.forEach((item) => {
    query += `
      ${makeid(10)}: ${productQuery(item.field.value)}
    `;
  });

  query += `}`;

  return query;
};

const productQuery = (id) => {
  return `
    product(id: "${id}") {
      id
      title
      availableForSale
      featuredCollection: metafield(key: "featured_collection", namespace: "custom") {
          value
        }      
      media(first: 1) {
        nodes {
          previewImage {
            url(transform: {maxHeight: 200, maxWidth: 200})
          }
        }
      }
      variants (first: 10) {
        nodes {
          id
          title
          price {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
            currencyCode
          }
          image {
            url(transform: {maxHeight: 200, maxWidth: 200})
          }
          sellingPlanAllocations(first: 10) {
            nodes {
              sellingPlan {
                name
                options {
                  name
                  value
                }
                id
              }
            }
          }
        }
      }
    }
  `;
};

const cart = (shippingAmount) => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('items', []);
    Alpine.store('upsellOptions', []);
    Alpine.store('genericUpsells', []);
    Alpine.store('totalPrice', 0);
    Alpine.store('totalItems', 0);
    Alpine.store('shippingAmount', shippingAmount);

    Alpine.data('cart', (shippingAmount) => ({
      open: false,
      loading: true,
      addingUpsell: false,
      items: [],
      upsellOptions: [],
      totalPrice: 0,
      totalItems: 0,
      shippingAmount: shippingAmount,
      totalCompareSub: 0,
      totalCompareOneOff: 0,
      overlayOpen(e) {
        if (e.detail.overlay !== 'cart') {
          this.closeCart();
        }
      },
      init() {
        this.getCart();
      },
      closeCart() {
        this.open = false;
        this.$dispatch('overlay:close', { overlay: 'cart' });

        const reamze = document.querySelector('#reamaze-widget-container');
        if (reamze) {
          reamze.style.display = 'block';
        }
      },
      toggleCart() {
        this.open = !this.open;

        const reamze = document.querySelector('#reamaze-widget-container');

        if (this.open) {
          this.$dispatch('overlay:open', { overlay: 'cart' });
          if (reamze) {
            reamze.style.display = 'none';
          }
        } else {
          this.$dispatch('overlay:close', { overlay: 'cart' });
          if (reamze) {
            reamze.style.display = 'block';
          }
        }
      },
      getItemFromVariant(variantId) {
        return this.$store.items.find((item) => variantId.includes(item.variant_id));
      },
      getCart() {
        this.loading = true;

        fetch(`${window.Shopify.routes.root}cart.js`)
          .then((res) => res.json())
          .then((res) => {
            this.$store.items = res.items;
            this.$store.totalPrice = res.items_subtotal_price;
            this.$store.totalItems = res.item_count;
            this.$store.shippingAmount = shippingAmount;


            let freeGiftTotal = 0;

            this.$store.items.forEach(item => {
              if (item.properties && 'DiscountNinja.FreeGift.CEHNN' in item.properties && item.line_price > 0) {
                freeGiftTotal += item.price * item.quantity;
              }
            });

            this.$store.totalPrice = res.items_subtotal_price - freeGiftTotal;


            this.$dispatch('cart:updated', {
              items: res.items,
              totalPrice: res.items_subtotal_price - freeGiftTotal,
              totalItems: res.item_count,
            });

            this.updateShippingTotals(this.$store.shippingAmount, this.$store.totalPrice);

            this.getUpsellOptions();
            this.calculateSaving();
          })
          .catch((err) => {})
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
              }, 3000);
          });
      },
      makeid(length) {
        return makeid(length);
      },
      updateShippingTotals(shippingLimit, cartTotal) {
        var shippingTexts = document.querySelectorAll('.shipping-text');

        shippingTexts.forEach((shippingWrapper) => {
          var totalRemaining = shippingLimit - cartTotal;

          if (totalRemaining > 0) {
            var allRemainingText = document.querySelectorAll('.shipping-remaining');

            var valueInPounds = totalRemaining / 100;
            var formattedValue = valueInPounds.toFixed(2);
            var currencyValue = '£' + formattedValue;

            shippingWrapper.innerHTML =
              '<span class="shipping-text">Spend just <span class="font-bold shipping-remaining">' +
              currencyValue +
              '</span> to qualify for free standard UK delivery</span>';

            allRemainingText.forEach((remainingText) => {
              remainingText.innerHTML = currencyValue;
            });

            // Calculate progress bar
            var progressBar = document.querySelectorAll('.progress-bar');
            var percentageDiff = (cartTotal / shippingLimit) * 100;

            progressBar.forEach((bar) => {
              bar.style.width = percentageDiff + '%';
            });
          } else {
            shippingWrapper.innerHTML = "You've qualified for free delivery";
            var progressBar = document.querySelectorAll('.progress-bar');

            progressBar.forEach((bar) => {
              bar.style.width = '100%';
            });
          }
        });
      },
      getUpsellOptions() {
        let query = '';
      
        const metafieldQuery = `
          metafield(key: "related_products", namespace: "custom") {
            value
          }
        `;
      
        if (this.$store.items.length === 0) {
          this.$store.upsellOptions = [];
          return;
        }
      
        query = 'query {';
        this.$store.items.forEach((item) => {
          if (item.options_with_values.length === 0) {
            return;
          }
      
          query += `
            ${this.makeid(10)}: productByHandle(handle: "${item.handle}") {
              ${metafieldQuery}
              variantBySelectedOptions(selectedOptions: {name: "${item.options_with_values[0].name}", value: "${item.options_with_values[0].value}"}) {
                id
                image {
                  url(transform: {maxHeight: 200, maxWidth: 200})
                }
                sellingPlanAllocations(first: 10) {
                  nodes {
                    sellingPlan {
                      name
                      options {
                        name
                        value
                      }
                      id
                    }
                  }
                }
              }
            }
          `;
        });
      
        query += `
          general_upsells: metaobjects(type: "general_cart_upsells", first: 10) {
            nodes {
              id
              field(key: "product") {
                value
                key
              }
            }
          }
        `;
      
        query += '}';
      
        const variantIds = [];
        const variantImgs = [];
        let genericUpsells = [];
      
        this.graphqlQuery(query)
          .then((d) => {
            query = '{';
      
            Object.keys(d.data).forEach((key) => {
              if (!d.data[key].metafield) {
                return;
              }
      
              variantIds.push(d.data[key].variantBySelectedOptions.id);
              variantImgs.push(d.data[key].variantBySelectedOptions.image.url);
      
              const { value } = d.data[key].metafield;
              const valueExploded = JSON.parse(value);
      
              valueExploded.forEach((val) => {
                query += `
                  ${this.makeid(10)}: ${productQuery(val)}
                `;
              });
            });
      
            query += '}';
      
            genericUpsells = d.data.general_upsells.nodes;
      
            return this.graphqlQuery(query);
          })
          .then((d) => {
            let collectionGIDs = [];
            if (d.data) {
              const upsellOptions = [];

              Object.keys(d.data).forEach((key, index) => {
                const upsellOption = this.generateUpsell(d.data[key]);
                upsellOptions.push(upsellOption);

                const { featuredCollection } = d.data[key];
        
                if (featuredCollection && featuredCollection.value) {
                  collectionGIDs.push(featuredCollection.value);
                }
  
              });
      
              const uniqueUpsellOptions = [];
      
              upsellOptions.forEach((upsellOption) => {
                if (!upsellOption) {
                  return;
                }
      
                const variantId = upsellOption.id;
      
                const inUpsellOptions = uniqueUpsellOptions.find((option) => option.id === variantId);
      
                if (!inUpsellOptions) {
                  uniqueUpsellOptions.push(upsellOption);
                }
              });
      
              this.$store.upsellOptions = uniqueUpsellOptions;
            }
      

          })
          .then((d) => {
            return this.graphqlQuery(generalUpsells(genericUpsells));
          })
          .then((d) => {
            let collectionGIDs = [];
            if (d.data) {
              const opts = [];
      
              Object.keys(d.data).forEach((key) => {
                const upsellOption = this.generateUpsell(d.data[key]);
                const { featuredCollection } = d.data[key];
        
                if (featuredCollection && featuredCollection.value) {
                  collectionGIDs.push(featuredCollection.value);
                }
                opts.push(upsellOption);
              });
      
              const uniqueUpsellOptions = [];
      
              opts.forEach((upsellOption) => {
                if (!upsellOption) {
                  return;
                }
      
                const variantId = upsellOption.id;
      
                const inUpsellOptions = uniqueUpsellOptions.find((option) => option.id === variantId);
      
                if (!inUpsellOptions) {
                  uniqueUpsellOptions.push(upsellOption);
                }
              });
      
              this.$store.genericUpsells = uniqueUpsellOptions;
            }
          });
      },      
      generateUpsell(upsell) {
        let inCart = this.$store.items.find((item) => upsell.id.includes(item.product_id));

        if (!inCart && upsell.availableForSale) {
          let availableSellingPlans = [];

          upsell.variants.nodes.forEach((variant) => {
            variant.sellingPlanAllocations.nodes.forEach((sellingPlan) => {
              availableSellingPlans.push({
                value: sellingPlan.sellingPlan.id.split('/').at(-1),
                label: sellingPlan.sellingPlan.name,
              });
            });
          });

          // make unique
          availableSellingPlans = availableSellingPlans.filter(
            (obj, i, arr) => arr.findIndex((obj2) => ['label', 'value'].every((key) => obj[key] === obj2[key])) === i
          );

          return {
            id: upsell.id,
            title: upsell.title,
            image: upsell.media.nodes[0]?.previewImage.url,
            variants: upsell.variants.nodes,
            variant: upsell.variants.nodes[0].id,
            price: upsell.variants.nodes[0].price.amount,
            compareAtPrice: upsell.variants.nodes[0].compareAtPrice?.amount,
            currency: upsell.variants.nodes[0].price.currencyCode,
            featuredCollection: upsell.featuredCollection,
            availableSellingPlans,
          };
        }

        return null;
      },
      graphqlQuery: async (query) => {
        const res = await fetch(`${window.Shopify.routes.root}api/2024-07/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/graphql',
            'X-Shopify-Storefront-Access-Token': '0619ec81325b1c39a14b4ef234756bde',
          },
          body: query,
        });

        const data = await res.json();

        return data;
      },
      upsellClicked() {
        this.addingUpsell = true;
        const { variant, upsellVariant, upsellType, upsell } = this.$el.dataset;

        const lineItem = {
          id: variant.split('/').at(-1),
          quantity: 1
        };

        this.addItem(lineItem)
          .then(this.getUpsellOptions())
          .finally(() => {
            this.addingUpsell = false;
            this.updateShippingTotals(this.$store.shippingAmount, this.$store.totalPrice);
          });
      },
      changeItem(data) {
        this.loading = true;
        return fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => {
            if (res.status && res.status !== 200) {
              throw new Error(res.description);
            }

            this.$store.items = res.items;
            this.$store.totalItems = res.item_count;

            let freeGiftTotal = 0;

            this.$store.items.forEach(item => {
              if (item.properties && 'DiscountNinja.FreeGift.CEHNN' in item.properties) {
                freeGiftTotal += item.price * item.quantity;
              }
            });

            this.$store.totalPrice = res.items_subtotal_price - freeGiftTotal;


            this.$dispatch('cart:updated', {
              items: res.items,
              totalPrice: res.items_subtotal_price - freeGiftTotal,
              totalItems: res.item_count,
            });

            this.updateShippingTotals(this.$store.shippingAmount, this.$store.totalPrice);

            this.getUpsellOptions();

            this.calculateSaving();

            return res;
          })
          .catch((err) => {
            this.error = err;
          })
          .finally((res) => {
            setTimeout(() => {
              this.loading = false;
              }, 3000);
          });
      },
      addItem(data) {
        this.loading = true;

        const lineItems = [];

        const lineItem = data;

        lineItems.push(lineItem);

        return fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: lineItems }),
        })
          .then((res) => res.json())
          .then((res) => {
            this.getCart();

            return res;
          })
          .catch((err) => {})
          .finally(() => {
            setTimeout(() => {
            this.loading = false;
            }, 3000);
          });
      },
      removeItem(variantId) {
        this.loading = true;

        const updates = {
          updates: {
            [variantId]: 0,
          },
        };

        return fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updates),
        })
          .then((res) => res.json())
          .then((res) => {
            this.$store.items = res.items;
            this.$store.totalPrice = res.items_subtotal_price;
            this.$store.totalItems = res.item_count;

            let freeGiftTotal = 0;

            this.$store.items.forEach(item => {
              if (item.properties && 'DiscountNinja.FreeGift.CEHNN' in item.properties) {
                freeGiftTotal += item.price * item.quantity;
              }
            });

            this.$store.totalPrice = res.items_subtotal_price - freeGiftTotal;

            this.$dispatch('cart:updated', {
              items: res.items,
              totalPrice: res.items_subtotal_price - freeGiftTotal,
              totalItems: res.item_count,
            });

            this.updateShippingTotals(this.$store.shippingAmount, this.$store.totalPrice);

            this.calculateSaving();

            return res;
          })
          .catch((err) => {})
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
              }, 3000);
          });
      },
      remove() {
        this.loading = true;

        const variantId = this.$el.dataset.variant;
        const upsellVariant = this.$el.dataset.upsellVariant;

        const updates = {
          updates: {
            [variantId]: 0,
          },
        };

        if (upsellVariant) {
          updates.updates[upsellVariant] = 0;
        }

        fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updates),
        })
          .then((res) => res.json())
          .then((res) => {
            this.$store.items = res.items;
            this.$store.totalPrice = res.items_subtotal_price;
            this.$store.totalItems = res.item_count;

            let freeGiftTotal = 0;

            this.$store.items.forEach(item => {
              if (item.properties && 'DiscountNinja.FreeGift.CEHNN' in item.properties) {
                freeGiftTotal += item.price * item.quantity;
              }
            });

            this.$store.totalPrice = res.items_subtotal_price - freeGiftTotal;

            this.$dispatch('cart:updated', {
              items: res.items,
              totalPrice: res.items_subtotal_price - freeGiftTotal,
              totalItems: res.item_count,
            });

            this.updateShippingTotals(this.$store.shippingAmount, this.$store.totalPrice);

            this.getUpsellOptions();
            this.calculateSaving();

          })
          .catch((err) => {})
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
              }, 3000);
          });
      },
      currencyCodeToSymbol(currencyCode) {
        switch (currencyCode) {
          case 'USD':
            return '$';
          case 'GBP':
            return '£';
          case 'EUR':
            return '€';
          case 'AUD':
            return 'A$';
          case 'CAD':
            return 'C$';
          case 'JPY':
            return '¥';
          default:
            return currencyCode;
        }
      },
      formatPrice(price, currencyCode) {
        return `${this.currencyCodeToSymbol(currencyCode)}${price}`;
      },
      increase() {
        this.loading = true;

        const variantId = this.$el.dataset.variant;
        const qty = this.$el.dataset.qty;

        const updates = {
          id: variantId,
          quantity: parseInt(qty) + 1,
        };

        this.changeItem(updates);
      },
      decrease() {
        this.loading = true;

        const variantId = this.$el.dataset.variant;
        const qty = this.$el.dataset.qty;

        const updates = {
          id: variantId,
          quantity: parseInt(qty) - 1,
        };

        this.changeItem(updates);
      },
      calculateSaving() {
        this.totalCompareSub = 0;
        this.totalCompareOneOff = 0;

        this.$store.items.forEach((item) => {
          if (!(item.properties && 'DiscountNinja.FreeGift.CEHNN' in item.properties)) {
          if (item.selling_plan_allocation?.compare_at_price) {
            const originalPrice = item.selling_plan_allocation.compare_at_price * item.quantity;
            this.totalCompareSub += originalPrice;
          } else {
            const originalPrice = item.price * item.quantity;
            this.totalCompareOneOff += originalPrice;
          }
        }
        });
      },
      setSellingPlan(checked, sellingPlan) {
        const variant = this.$el.dataset.key;

        if (checked && sellingPlan) {
          this.loading = true;

          const updates = {
            id: variant,
            selling_plan: parseInt(sellingPlan),
          };

          this.changeItem(updates);
        }

        if (!checked) {
          this.loading = true;

          const updates = {
            id: variant,
            selling_plan: null,
          };

          this.changeItem(updates);
        }
      },
    }));
  });
};

export default cart;
